/* global $, API */

import { Controller } from 'stimulus';

class CartSuccessController extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    //
  }

  onCheckboxChange(e) {
    this.updateCartMaintenanceContract(e.currentTarget.checked);
  }

  updateCartMaintenanceContract(checked) {
    $.ajax({
      type: 'POST',
      url: API.cartMaintenanceContract,
      dataType: 'json',
      data: {
        checked,
      },
    });
  }
}

CartSuccessController.targets = [
  'checkbox',
];

export default CartSuccessController;
